<template lang="html">
<div id="app" class="sl-mini-page" :class="[themeClass]">
  <nprogress-container></nprogress-container>
  <router-view></router-view>
  <div v-if="$store.state.userAgent.isPhone && $store.state.user.userinfo !== null && versions === 'ios'" class="sl-download-app" v-show="popWindow">
    <b @click="popWindow = false">X</b>
    <div>
      <a href="https://itunes.apple.com/app/ai-merchant/id1265743674">Please download the newest version APP</a>
    </div>
  </div>
</div>
</template>

<style scoped>
#app {
  height: 100%;
}
</style>

<script>
import * as types from './store/types'
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
export default {
  data() {
    return {
      themeClass: this.$store.state.theme.name,
      popWindow: true,
      versions: ''
    }
  },
  components: {
    NprogressContainer
  },
  beforeCreate() {
    var favLink = document.createElement('link')
    favLink.href = `/static/${this.$store.state.theme.name}/128_favicon.ico`
    favLink.rel = 'shortcut icon'
    favLink.sizes = '48x48'
    document.getElementsByTagName('head')[0].appendChild(favLink)
    const themeLink = document.createElement('link')
    themeLink.href = `/static/${this.$store.state.theme.name}/theme-item.css`
    themeLink.rel = 'stylesheet'
    document.getElementsByTagName('head')[0].appendChild(themeLink)
  },
  created() {
    this.$store.commit(types.AGENT, this.isPhone())
  },
  methods: {
    isPhone() {
      const u = navigator.userAgent
      const versions = {
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        ios: u.indexOf('iPhone') > -1
      }
      this.versions = versions.ios ? 'ios' : 'android'
      if (versions.mobile || versions.android || versions.ios) {
        return true
      }
      return false
    }
  }
}
</script>
<style>
.nprogress-container {
  position: fixed!important;
  width: 100%;
  /*height: 51px;*/
  height: 1px;
  z-index: 2048;
  pointer-events: none;
}

#nprogress .bar {
  background-color: #ee3702 !important;
}

#nprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px #ee3702, 0 0 5px #ee3702 !important;
  opacity: 1.0;
  -webkit-transform: rotate(3deg) translate(0px, -4px);
  -ms-transform: rotate(3deg) translate(0px, -4px);
  transform: rotate(3deg) translate(0px, -4px);
}

.sl-download-app {
  height: 50px;
  width: 100%;
  position: fixed;
  bottom: 0;
  background: rgba(0, 0, 0, .7);
  z-index: 2000;
}

.sl-download-app b {
  font-size: 16px;
  position: relative;
  top: 5px;
  left: 5px;
  color: #fff;
}

.sl-download-app div {
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  display: inline-block;
  width: 100%;
  position: relative;
  top: -5px;
  cursor: pointer;
  text-decoration: underline;
}

.sl-download-app a {
  color: #4990E2;
}
</style>



// WEBPACK FOOTER //
// App.vue?3f85220e